<template>
  <div id="app" class="app-shell">
    <Header />
    <main class="app-main">
      <router-view />
    </main>
    <Footer />
    <GoTop />
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import GoTop from './components/GoTop.vue'

export default {
  name: 'App',
  components: {
    Header,
    Footer,
    GoTop
  }
}
</script>

<style lang="scss">
.app-shell {
  min-height: 100vh;
  background: var(--color-parchment);
}

.app-main {
  min-height: calc(100vh - 360px);
}
</style>
